import { NoteTeethGroup } from '@/shared/api/protocol-ts/model/dto_scribe_catalog_pb';

import { i18n } from '../config';

import { useTemplateIntl } from './useTemplateIntl';

// A teeth group as the note prints it, in the template language.
export const useNoteTeethGroupName = (language: string | undefined) => {
  const templateIntl = useTemplateIntl(language);
  return (group: NoteTeethGroup) =>
    templateIntl.formatMessage(
      i18n.noteTeethGroupTextMessages[group] ??
        i18n.noteTeethGroupTextMessages[
          NoteTeethGroup.NoteTeethGroupInvalidValue
        ],
    );
};
